'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_types$RestrictedDomainId$() {
  this.c9J = null;
  this.c9K = false;
  this.c9H = null;
  this.c9I = false;
}
export { $c_Lpresto_types$RestrictedDomainId$ as $c_Lpresto_types$RestrictedDomainId$ };
$p = $c_Lpresto_types$RestrictedDomainId$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$RestrictedDomainId$;
/** @constructor */
function $h_Lpresto_types$RestrictedDomainId$() {
}
export { $h_Lpresto_types$RestrictedDomainId$ as $h_Lpresto_types$RestrictedDomainId$ };
$h_Lpresto_types$RestrictedDomainId$.prototype = $p;
$p.H8 = (function() {
  if ((!this.c9K)) {
    this.c9J = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Encoder$().j9;
    this.c9K = true;
  }
  return this.c9J;
});
$p.lj = (function() {
  if ((!this.c9I)) {
    this.c9H = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().e1;
    this.c9I = true;
  }
  return this.c9H;
});
var $d_Lpresto_types$RestrictedDomainId$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$RestrictedDomainId$, "presto.types$RestrictedDomainId$", ({
  a16: 1,
  D: 1
}));
export { $d_Lpresto_types$RestrictedDomainId$ as $d_Lpresto_types$RestrictedDomainId$ };
var $n_Lpresto_types$RestrictedDomainId$;
function $m_Lpresto_types$RestrictedDomainId$() {
  if ((!$n_Lpresto_types$RestrictedDomainId$)) {
    $n_Lpresto_types$RestrictedDomainId$ = new $c_Lpresto_types$RestrictedDomainId$();
  }
  return $n_Lpresto_types$RestrictedDomainId$;
}
export { $m_Lpresto_types$RestrictedDomainId$ as $m_Lpresto_types$RestrictedDomainId$ };
//# sourceMappingURL=presto.types$-Restricted-Domain-Id$.js.map
